'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPE = undefined;
exports.processor = processor;
exports.default = call;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isGenerator = require('is-generator');

var _isPromise = require('is-promise');

var _isPromise2 = _interopRequireDefault(_isPromise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var TYPE = exports.TYPE = '__YIELD_EFFECT_CALL__';

function processor(effect, _ref) {
  var dispatch = _ref.dispatch;
  var effectGeneratorProcessor = _ref.effectGeneratorProcessor;
  var _effect$payload = effect.payload;
  var func = _effect$payload.func;
  var args = _effect$payload.args;


  (0, _invariant2.default)((0, _isFunction2.default)(func), '"effect.payload.func" must be a function, but received ' + func);

  var promise = undefined;
  if ((0, _isGenerator.fn)(func)) {
    // func is an effect generator
    promise = effectGeneratorProcessor(func.apply(undefined, _toConsumableArray(args)), { dispatch: dispatch });
  } else {
    promise = func.apply(undefined, _toConsumableArray(args));

    (0, _invariant2.default)((0, _isPromise2.default)(promise), '"effect.payload.func" must return a promise, but received ' + promise);
  }

  return promise;
}

function call(func) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return {
    type: TYPE,
    payload: {
      func: func,
      args: args
    }
  };
}


// WEBPACK FOOTER //
// ./node_modules/redux-yield-effect/lib/effects/call.js